module.exports = __webpack_public_path__ + "static/img/ba_s_2.256861f5.png";